import React from "react";
import { fmtDiasEmFila } from "../../../utils/calculos";
import { F } from "../../../utils/gerencialFields";
import { entradaEtapa, ETAPA_LABELS, getEtapaAtual } from "../../../utils/toc/etapas";
import { ZONA_LABELS } from "../../../utils/toc/bufferManager";
import {
  CriticosTable,
  CriticosTableWrapper,
  CriticosTd,
  CriticosTh,
  EmptyHint,
  ZONE_TONES,
  ZonePill,
  ZoneSwatch,
} from "./styles";

function formatPct(value) {
  if (value == null || !Number.isFinite(value)) return "—";
  return `${Math.round(value * 100)}%`;
}

function nomeAmbiente(amb) {
  return amb?.[F.AMBIENTE] || "—";
}

function nomeCliente(amb) {
  return amb?.[F.NOME_DO_CLIENTE] || "—";
}

function pedidoAmbiente(amb) {
  return amb?.[F.NUMERO_DO_PEDIDO] || "—";
}

export default function CriticalAmbientsTable({ criticos }) {
  if (!criticos || criticos.length === 0) {
    return (
      <CriticosTableWrapper>
        <EmptyHint>
          Nenhum ambiente em zona crítica. Bom momento para liberar mais para
          Compras.
        </EmptyHint>
      </CriticosTableWrapper>
    );
  }

  return (
    <CriticosTableWrapper>
      <CriticosTable>
        <thead>
          <tr>
            <CriticosTh>Pedido</CriticosTh>
            <CriticosTh>Cliente</CriticosTh>
            <CriticosTh>Ambiente</CriticosTh>
            <CriticosTh>Etapa</CriticosTh>
            <CriticosTh $center>Dias em fila</CriticosTh>
            <CriticosTh $center>Pulmão</CriticosTh>
            <CriticosTh $right>% Consumido</CriticosTh>
          </tr>
        </thead>
        <tbody>
          {criticos.map(({ amb, status }, index) => {
            const etapa = getEtapaAtual(amb);
            const tone = ZONE_TONES[status.zona] || "default";
            return (
              <tr key={`${pedidoAmbiente(amb)}-${nomeAmbiente(amb)}-${index}`}>
                <CriticosTd>{pedidoAmbiente(amb)}</CriticosTd>
                <CriticosTd>{nomeCliente(amb)}</CriticosTd>
                <CriticosTd>{nomeAmbiente(amb)}</CriticosTd>
                <CriticosTd>{etapa ? ETAPA_LABELS[etapa] : "—"}</CriticosTd>
                <CriticosTd $center>
                  {fmtDiasEmFila(entradaEtapa(etapa, amb))}
                </CriticosTd>
                <CriticosTd $center>
                  <ZonePill $tone={tone}>
                    <ZoneSwatch $zone={status.zona} aria-hidden />
                    {ZONA_LABELS[status.zona] || "—"}
                  </ZonePill>
                </CriticosTd>
                <CriticosTd $right>
                  {formatPct(status.pctConsumido)}
                </CriticosTd>
              </tr>
            );
          })}
        </tbody>
      </CriticosTable>
    </CriticosTableWrapper>
  );
}
